import DateForecastCard from "@/components/consumer_post_card/group_forecast_card/date_forecast_card";
import NumericForecastCard from "@/components/consumer_post_card/group_forecast_card/numeric_forecast_card";
import PercentageForecastCard from "@/components/consumer_post_card/group_forecast_card/percentage_forecast_card";
import TimeSeriesChart from "@/components/consumer_post_card/time_series_chart";
import { GroupOfQuestionsGraphType, PostWithForecasts } from "@/types/post";
import { QuestionType } from "@/types/question";
import { getGroupForecastAvailability } from "@/utils/questions/forecastAvailability";
import { sortGroupPredictionOptions } from "@/utils/questions/groupOrdering";
import {
  checkGroupOfQuestionsPostType,
  isMultipleChoicePost,
  isNumericQuestionType,
} from "@/utils/questions/helpers";

type Props = {
  postData: PostWithForecasts;
};

const GroupOfQuestionsPrediction: React.FC<Props> = ({ postData }) => {
  let content: React.ReactNode | null = null;
  const questionsGroup = postData.group_of_questions;
  const groupType = questionsGroup?.questions[0]?.type;
  const isNumericGroup = !!groupType && isNumericQuestionType(groupType);

  if (
    isMultipleChoicePost(postData) ||
    checkGroupOfQuestionsPostType(postData, QuestionType.Binary)
  ) {
    content = <PercentageForecastCard post={postData} forceColorful />;
  } else if (questionsGroup && isNumericGroup) {
    if (questionsGroup.graph_type === GroupOfQuestionsGraphType.FanGraph) {
      // Check forecast availability for fan graphs
      const forecastAvailability = getGroupForecastAvailability(
        questionsGroup.questions
      );

      // Hide chart if no forecasts or CP not yet revealed
      const shouldHideChart =
        forecastAvailability &&
        (forecastAvailability.isEmpty || !!forecastAvailability.cpRevealsOn);

      if (!shouldHideChart) {
        const sortedQuestions = sortGroupPredictionOptions(
          questionsGroup.questions,
          questionsGroup
        );
        content = (
          <TimeSeriesChart
            questions={sortedQuestions}
            variant="colorful"
            height={180}
          />
        );
      }
    } else {
      content = <NumericForecastCard post={postData} />;
    }
  } else if (checkGroupOfQuestionsPostType(postData, QuestionType.Date)) {
    content = (
      <DateForecastCard
        post={postData}
        questionsGroup={postData.group_of_questions}
      />
    );
  }

  if (!content) return null;

  const wrapperClass =
    checkGroupOfQuestionsPostType(postData, QuestionType.Date) ||
    postData.group_of_questions?.graph_type ===
      GroupOfQuestionsGraphType.FanGraph
      ? "mb-7"
      : "mt-7";

  return <div className={wrapperClass}>{content}</div>;
};

export default GroupOfQuestionsPrediction;
